// @flow
import { localStorage } from '@rover/utilities/storage';

const KEY_HOME_DESCRIPTION = 'conversation_home_description';

const saveValue = (key: string, conversationOpk: string, value: string) => {
  if (value) {
    localStorage.setItem(key, `${conversationOpk};${value}`);
  } else {
    localStorage.removeItem(key);
  }
};

const getValue = (key: string, conversationOpk: ?string) => {
  const stringValue = localStorage.getItem(key) || '';
  const splitValues = stringValue.split(';');
  const savedOpk = splitValues.shift();
  const value = splitValues.join(';');
  if (conversationOpk === null || conversationOpk === savedOpk) {
    return value;
  }
  return '';
};

/**
 * Saves the given home description for the given conversation OPK.
 * Only the last saved home description is saved for any conversation.
 * The conversation OPK's is just to identify to which conversation
 * the saved description belongs to, so that it's not accidentally retrieved
 * for a different conversation.
 *
 * @param conversationOpk
 * @param homeDescription
 */
export const saveHomeDescription = (conversationOpk: string, homeDescription: string) => {
  saveValue(KEY_HOME_DESCRIPTION, conversationOpk, homeDescription);
};

/**
 * Retrieves the last saved home description if it corresponds to the given conversation OPK.
 * An empty string is returned if there's no saved home description or there is one saved for a different conversation.
 *
 * @param conversationOpk
 */
export const getSavedHomeDescription = (conversationOpk: string) => {
  return getValue(KEY_HOME_DESCRIPTION, conversationOpk);
};

/**
 * Retrieves the last saved home description for any conversation.
 */
export const getLastSavedHomeDescription = () => {
  return getValue(KEY_HOME_DESCRIPTION, null);
};



// WEBPACK FOOTER //
// ../react-lib/src/pages/contact-sitter/ContactSitterPage/api/contactDataHelper.js